// /**
//  *  Imports
//  */
import axios from 'axios';
import configs from 'config';
import API_CONSTANT from 'constants/apiConstant';
import { toast } from 'react-toastify';
import { ChangeHistory, getAppInfo, getAppVersion, getURLParameter, nativeHandler } from 'utils';
import globalConstant from 'constants/globalConstant';
import msgConstants from 'constants/msgConstant';
import APP_ROUTES_CONSTANT from 'constants/appRouteConstants';

window.androidObj.nativeSupport = () => {};
const appInfo = (localStorage.getItem('appInfo') && JSON.parse(localStorage.getItem('appInfo'))) || {};

const defaultInterceptorConfig = {
	defaultLoader: true,
	handleRetry: false,
	useMetaData: false,
};

const loaderDetails = {
	first_message: 'loading',
	start_index: 0,
	range: 7,
	second_message: 'please wait',
};

/**
 *  API call via Promise
 */
const api = axios.create({
	baseURL: '',
	timeout: 60000,
});

// request interceptor
api.interceptors.request.use((config) => {
	if (window.navigator.onLine) {
		var visa =
			getAppInfo()?.[globalConstant.URL_PARAMETER.TOKEN] ||
			getAppInfo()?.[globalConstant.URL_PARAMETER.VISA] ||
			getURLParameter(globalConstant.URL_PARAMETER.TOKEN);
		config.options = { ...defaultInterceptorConfig, ...config.options };
		if (!visa) return;
		if (config.urlType === API_CONSTANT.URL_TYPE.HANDSHAKE) {
			config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
			config.data.append('visa', visa);
		} else {
			config.headers['Content-Type'] = 'application/json;';
			config.headers['token'] = visa;
			config.headers['latitude'] =
				getAppInfo()?.latitude || getURLParameter(globalConstant.URL_PARAMETER.LATITUDE) || '';
			config.headers['longitude'] =
				getAppInfo()?.longitude || getURLParameter(globalConstant.URL_PARAMETER.LONGITUDE) || '';
			// if(config.url === API_CONSTANT.URL.INITIATE_PAYMENT) {
			//   config.headers["latitude"] = localStorage.getItem("latitude") || "";
			//   config.headers["longitude"] = localStorage.getItem("longitude") || "";
			// }
			if (config.urlType === 'merchantUat')
				config.headers = {
					...config.headers,
					...appInfo,
				};
			if (!config.options.dontSendSimDetails) {
				config.headers['installid'] =
					getAppInfo()?.[globalConstant.URL_PARAMETER.INSTALL_ID] ||
					getURLParameter(globalConstant.URL_PARAMETER.INSTALL_ID) ||
					'';
				config.headers['device'] =
					getAppInfo()?.[globalConstant.URL_PARAMETER.DEVICE_ID] ||
					getURLParameter(globalConstant.URL_PARAMETER.DEVICE_ID) ||
					'';
				config.headers['simid'] =
					getAppInfo()?.[globalConstant.URL_PARAMETER.SIM_ID] ||
					getURLParameter(globalConstant.URL_PARAMETER.SIM_ID) ||
					'';
				config.headers['appversion'] =
					getAppVersion() || getURLParameter(globalConstant.URL_PARAMETER.APPVERSION)?.trim() || '';
			}
		}
		config['baseURL'] = configs[config['urlType']];
		if (config.method.toUpperCase() === 'POST' && config['urlType'] !== API_CONSTANT.URL_TYPE.HANDSHAKE) {
			config.data = {
				...config.data,
				latitude: getAppInfo()?.latitude || getURLParameter(globalConstant.URL_PARAMETER.LATITUDE) || '',
				longitude: getAppInfo()?.longitude || getURLParameter(globalConstant.URL_PARAMETER.LONGITUDE) || '',
			};
		}
		config.loaderDetails = { ...loaderDetails, ...config.loaderDetails };
		// show default loader
		if (config.options.defaultLoader) {
			nativeHandler.showLoader(config.loaderDetails);
		}

		if (config.data === undefined) {
			config.data = null;
		}
		return config;
	}
});

// response interceptor
api.interceptors.response.use(
	(resp) => {
		const { options } = resp.config;
		// hide default loader when it's show on request time
		if (options.defaultLoader && !options.dontRemoveLoader) {
			setTimeout(() => {
				nativeHandler.removeLoader();
			}, 0);
		}

		// response error handling
		if (
			(resp.data &&
				(resp.data.success === false || resp.data.status === false || resp.data.response === 'failed') &&
				resp.data?.message !== 'FAILED') ||
			(resp.data?.statusCode && resp.data?.statusCode !== '200')
		) {
			let message = resp.data?.message || msgConstants.SOMETHING_WRONG;
			!options.restrictToast && toast.error(message);

			// show retry screen according to handleRetry value
			if ((options.handleRetry && resp.status !== 404) || !window.navigator.onLine) {
				ChangeHistory('push', APP_ROUTES_CONSTANT.somethingWrong);
			}
		}
		return resp;
	},
	(err) => {
		// if you have no specific plan B for errors, let them be handled here with a notification
		const { config } = err;
		const { data, status } = err.response || { status: 0 };

		// check is request canceled by client
		if (axios.isCancel(err)) {
			nativeHandler.removeLoader();
		} else {
			let message = data?.message || msgConstants.SOMETHING_WRONG;
			if (config.options.defaultLoader && (status !== 404 || data?.statusCode !== '200')) {
				nativeHandler.removeLoader();
			}

			if (config.options.handleRetry && status !== 404 && status !== 503) {
				nativeHandler.removeLoader();
				ChangeHistory('push', APP_ROUTES_CONSTANT.somethingWrong);
			}
		}
		return { status, data };
	},
);

export default api;
